<template>
  <div class="multiple-selection-module">
    <p
      :class="{ 'multiple-selection-module__instructions--view-mode': mode === 'VIEW' }"
      class="multiple-selection-module__instructions"
    >
      {{ mode === 'EDIT'
        ? $t('Select all answers that apply')
        : decodeHTML(moduleData.options.content) }}
    </p>
    <TEIError :validation-error="validationError" />
    <InteractiveModulePrompt
      v-if="mode === 'EDIT'"
      class="multiple-selection-module__prompt"
      :canvas-name="canvasName"
      :module-data="clonedModuleData"
      :id="id"
      @update-module="validateAndUpdateTEI"
    />

    <MultipleChoiceEditor
      v-if="mode === 'EDIT'"
      :canvas-name="canvasName"
      :module-data="clonedModuleData"
      type="multiple"
      :id="id"
      :scale="scale"
      @update-module="validateAndUpdateTEI"
    />
    <MultipleChoiceViewer
      v-else
      :module-data="clonedModuleData"
      type="multiple"
    />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { decodeHTML } from '@/lib/utils';
import moduleData from '@/mixins/moduleData';
import teiValidation from '@/mixins/teiValidation';
import InteractiveModulePrompt from './InteractiveModulePrompt.vue';
import MultipleChoiceViewer from './MultipleChoiceViewer.vue';
import TEIError from './TEIError.vue';

const MultipleChoiceEditor = defineAsyncComponent(() => import(/* webpackChunkName: "edit-mode" */ './MultipleChoiceEditor.vue'));

export default {
  name: 'MultipleSelectionModule',
  components: {
    InteractiveModulePrompt,
    MultipleChoiceEditor,
    MultipleChoiceViewer,
    TEIError,
  },
  mixins: [moduleData, teiValidation],
  props: {
    canvasName: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
    moduleData: {
      type: Object,
      required: true,
    },
    scale: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    decodeHTML,
  },
};
</script>

<style lang="stylus">
.multiple-selection-module {
  background-color: $nebula-color-white;
  padding: $nebula-space-2x;

  &__instructions {
    color: $comet-color-neutral-50;
    font-size: $nebula-font-size-caption;
    font-weight: bold;
    margin: 0 0 $nebula-space-1x 0;

    &--view-mode {
      margin: 0 0 $nebula-space-2x 0;
    }
  }

  &__prompt {
    margin: 0 0 $nebula-space-2x 0;
  }
}
</style>
